import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class DeActiveGuard implements CanActivate {
  constructor(private rest : AuthService , private router: Router){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.rest.getLoginStatus()) {
        console.log(this.rest.getLoginStatus())
        this.router.navigate(['pages/Dashboard']);
      }
      return true
  }
  
}
